import React, { useEffect, useRef } from 'react';

import { useParams } from 'react-router';
import { useEvent } from '../../../../../../data/hooks/eventHooks';
import { useLocalI18n } from '../../../../../../data/hooks/i18nHooks';
import useAnimatedVisibility from '../../../../../elements/AnimatedVisiblilty/useAnimatedVisibility';
import Icon from '../../../../../elements/icons/Icon';
import { useElementRect } from '../../useProtectedRegions';
import strings from '../BubblesFilter.i18n.csv';
import styles from './FilterMenu.module.scss';
import FilterMenuOption from './FilterMenuOption';

export const MAX_FILTER_MENU_OPTIONS = 8;

const FilterMenu = props => {
    const {options, moreHref, onClick, onRectUpdate} = props,
        i18n = useLocalI18n(strings),
        {mounted, visible, showing, hiding} = useAnimatedVisibility({
            visible: props.visible,
            timeout: 800,
        }),
        ref = useRef(),
        rect = useElementRect(ref),
        {eventId} = useParams(),
        event = useEvent(eventId);

    useEffect(() => {
        if (onRectUpdate) onRectUpdate(rect);
    }, [rect, onRectUpdate]);

    if (!mounted) return null;

    return (
        <div
            ref={ref}
            className={[styles.FilterMenu, visible ? styles.visible : styles.hidden, showing ? styles.showing : '', hiding ? styles.hiding : ''].join(' ')}>
            {options.slice(0, MAX_FILTER_MENU_OPTIONS).map((option, i) => (
                <FilterMenuOption visible={visible} className={option.className} option={option} key={i} onClick={onClick} />
            ))}
            <FilterMenuOption visible={visible && options.length > MAX_FILTER_MENU_OPTIONS && moreHref} className={styles.more} href={moreHref}>
                <Icon src="/img/ellipsis-horizontal.png" color={event.settings.secondary_color} />
            </FilterMenuOption>
        </div>
    );
};

export default FilterMenu;
